
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/customer-care",
      function () {
        return require("private-next-pages/help/customer-care/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/customer-care"])
      });
    }
  